import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export const GetLiveFeedV3Document = gql `
  query GetLiveFeedV3(
    $mainnetOnly: Boolean
    $page: Float
    $limit: Float
    $collectionId: String
    $chainId: Int
    $eventTypes: [LiveFeedEventType!]
    $query: String
    $minPriceNative: String
    $followingList: [String!]
    $watchingList: [String!]
  ) {
    getLiveFeedV3(
      mainnetOnly: $mainnetOnly
      page: $page
      limit: $limit
      collectionId: $collectionId
      chainId: $chainId
      eventTypes: $eventTypes
      query: $query
      minPriceNative: $minPriceNative
      followingList: $followingList
      watchingList: $watchingList
    ) {
      id
      chainId
      contractAddress
      editionId
      eventType
      collection {
        name
        image
      }
      contract {
        ownerAddress
        standard
      }
      tokenId
      token {
        name
      }
      amount {
        native
        raw
        usd
      }
      currency {
        symbol
      }
      from
      to
      transactionHash
      users {
        ownerAddress
        avatar
        name
        ens
      }
      createdAt
      updatedAt
    }
  }
`;
/**
 * __useGetLiveFeedV3Query__
 *
 * To run a query within a React component, call `useGetLiveFeedV3Query` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveFeedV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveFeedV3Query({
 *   variables: {
 *      mainnetOnly: // value for 'mainnetOnly'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      collectionId: // value for 'collectionId'
 *      chainId: // value for 'chainId'
 *      eventTypes: // value for 'eventTypes'
 *      query: // value for 'query'
 *      minPriceNative: // value for 'minPriceNative'
 *      followingList: // value for 'followingList'
 *      watchingList: // value for 'watchingList'
 *   },
 * });
 */
export function useGetLiveFeedV3Query(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLiveFeedV3Document, options);
}
export function useGetLiveFeedV3LazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLiveFeedV3Document, options);
}
